// extracted by mini-css-extract-plugin
module.exports = {"link-button":"ForgotPassword_link-button__2LEML","footer":"ForgotPassword_footer__2bYdp","is-invalid":"ForgotPassword_is-invalid__1Ft5_"};